import {
  LoginProgramInfo2025,
  LoginProgramInfo2026,
} from "pages/ProgramInfo/ProgramInfoContent";
import "./Intro.css";
import LegalFiles from "./LegalFiles";
import LegalFiles2026 from "./LegalFiles2026";

export default function Intro({ isProgramInfo2026 }) {
  const legalFiles = <LegalFiles />;
  const legalFiles2026 = <LegalFiles2026 />;

  return (
    <div className="intro-text">
      {isProgramInfo2026 ? (
        <LoginProgramInfo2026 legalFiles={legalFiles2026} />
      ) : (
        <LoginProgramInfo2025 legalFiles={legalFiles} />
      )}
    </div>
  );
}
